import Service from "../../service";

const getOrgId = () => {
  try {
    return (
      localStorage.getItem("orgId") ||
      JSON.parse(localStorage.getItem("getOrginasitionBySubDomain") || "{}")?._id ||
      JSON.parse(localStorage.getItem("organization") || "{}")?._id ||
      null
    );
  } catch { return null; }
};

const FundraisingAPI = {
  getCampaignBySlug: async (slug) => {
    try {
      const orgId = getOrgId();
      const qs = orgId ? `?org_id=${orgId}` : "";
      return await Service.get(`/finance/v1/campaign/public/${slug}${qs}`, null);
    } catch (error) {
      throw error;
    }
  },

  getDonors: async (campaignId, page = 1, limit = 10) => {
    try {
      return await Service.get(
        `/finance/v1/campaign/public/${campaignId}/donors?page=${page}&limit=${limit}`,
        null
      );
    } catch (error) {
      throw error;
    }
  },

  donateToCampaign: async (slug, data) => {
    try {
      const orgId = getOrgId();
      const qs = orgId ? `?org_id=${orgId}` : "";
      return await Service.post({
        url: `/finance/v1/campaign/public/${slug}/donate${qs}`,
        data,
        token: undefined,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default FundraisingAPI;
